import {Button, Grid} from "@material-ui/core";
import React, { useState } from "react";
import {DragAndDropList} from "../../../../components/common/DragAndDropList";
import {CodeLine} from "./CodeLine";
import { DeleteModal } from "./DeleteModal";

export const MarketingCodes = ({codes, setCodes}) => {

    const [codeToDelete, setCodeToDelete] = useState(null)

    const addCode = () => setCodes([...codes, {label: ''}])
    const deleteCode = () => setCodes(codes.filter((_, i) => i !== codeToDelete))
    const updateCode = (index, codeUpdated) =>
        setCodes(codes.map((code, i) => i === index ? codeUpdated : code))

    return (
        <Grid container xs={12}>
            <Grid item xs={12}>
                <DragAndDropList
                    items={codes}
                    setItems={setCodes}
                    itemComponent={CodeLine}
                    updateCode={updateCode}
                    deleteCode={setCodeToDelete}
                />
            </Grid>
            <Grid style={{ display: 'flex', alignItems: 'start', paddingTop: '16px'}} xs={12}>
                <Button
                    variant="raised"
                    className="primary-button pull-right margin-bottom-small"
                    style={{ marginLeft: "8px", display: "block" }}
                    onClick={addCode}
                >
                    Add
                </Button>
            </Grid>
            <DeleteModal open={codeToDelete !== null} onConfirm={deleteCode} onCancel={() => setCodeToDelete(null)} />
        </Grid>
    )
}



// WEBPACK FOOTER //
// ./src/containers/Settings/Shop/ManageReceipt/MarketingCodes.js